import React, {useCallback} from 'react'
import {TemplateDropboxHeader, TemplateDropboxMain} from 'pages/templates'
import {DropboxCreationContent} from '../CreationContent'
import {DropboxCreationPreview} from '../CreationPreview'

export default function DropboxCreation() {
  const handleRenderHeader = useCallback(
    () => <TemplateDropboxHeader iconType="image-alt" title="My Creation" />,
    [],
  )

  const handleRenderFolder = useCallback(() => <DropboxCreationContent />, [])

  const handleRenderPreview = useCallback(() => <DropboxCreationPreview />, [])

  return (
    <TemplateDropboxMain
      renderHeader={handleRenderHeader}
      renderInfo={handleRenderFolder}
      renderContent={handleRenderPreview}
    />
  )
}
